import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAlerts } from "../../contexts/AlertsContext";
import { useApiClient } from "../../contexts/ApiClientContext";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import DialogWindowType from "../common/dialog_window/DialogWindowType";
import AlertMessageType from "../common/alert_message/AlertMessageType";
import APIEndPoints from "../../utils/APIEndPoints";

function SpecialistRequired() {
  const navigate = useNavigate();
  const alertsManager = useAlerts();
  const apiClient = useApiClient();
  const userMessageRef = useRef<string>("");

  const handleRequest = () => {
    const desired_role = "Specialist";

    let user_upgrade_request_message =
      "This is an automated message generated at the request of a user. The user requests approval for elevated access rights to create Chemical Elements with the role of: " +
      desired_role +
      ".";

    user_upgrade_request_message += "\n\n Attached below is the user's provided justification: \n\n ";
    user_upgrade_request_message += userMessageRef.current;

    const body = {
      category: "specialist_request",
      message: user_upgrade_request_message,
    };

    apiClient
      ?.post({
        url: APIEndPoints.EMAILS.NEW,
        body: body,
      })
      .then(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.SUCCESS,
          message: "Request submitted successfully. An administrator will review your request shortly.",
        });
      })
      .catch(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.ERROR,
          message: "Failed to send request. Please try again later.",
        });
      });
  };


  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md">
        <div className="mb-6 text-center">
          <svg
            className="mx-auto h-16 w-16 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2m4-4l2 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4 text-center">
          Specialist Access Required
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Creating Chemical Elements requires Specialist or higher privileges.
          Please submit a formal request below, and an administrator will
          review it shortly.
        </p>

        <div className="flex gap-4">
          <Button
            label="Request"
            purpose={ButtonAction.INFO}
            isSubmit={false}
            onClick={() => {
              alertsManager.showDialogWindow({
                type: DialogWindowType.CONTACTFORM,
                message: "This will send your request to administrators who will review your application for Specialist access. Are you sure you want to submit this request?",
                cancelLabel: "Cancel",
                confirmLabel: "Yes, submit!",
                onConfirm: () => handleRequest(),
                onUserMessageChange: (msg) => {
                  userMessageRef.current = msg;
                },
              });
            }}
            className="w-1/2"
          />
          <button
            onClick={() =>
              navigate(
                SETTINGS.get_path({
                  section: AppSections.CHELEMENTS,
                })
              )
            }
            className="w-1/2 bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition duration-200"
          >
            Back to Records
          </button>
        </div>
      </div>
    </div>
  );
}

export default SpecialistRequired;
